import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"

// usage:
// <form data-controller="autosubmit" data-autosubmit-target="form">
//   <input type="text" name="query" data-action="autosubmit#submitForm" />
// TODO eliminar este controller y usar el auto-submit
export default class extends Controller {

  static targets = [ "form" ]

  static values = {
    confirmation: Boolean,
    confirmationMessage: String
  }

  initialize(){
    Loggable(this, {debug: false})
  }

  connect(){
    this.log("connected")
  }

  submitForm(event){
    if(this.confirmationValue){
      if(confirm(this.confirmationMessageValue)){
        this._submitForm()
      }
    } else {
      this._submitForm()
    }
  }

  _submitForm(){
    this.log("submitting form")
    if (typeof this.formElement.requestSubmit === "function") {
      this.formElement.requestSubmit()
    } else {
      this.formElement.submit()
    }
  }

  get formElement(){
    if (this.hasFormTarget) {
      return this.formTarget
    }

    return this.element
  }
}
